import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './VehicleInformation.module.css';

import { Divider } from 'antd';

const VehicleInformation = ({ vehicle }) => {
  const { t } = useTranslation();
  return (
    <>
      <h2>
        {vehicle?.vehicleMake.name} {vehicle?.vehicleModel.name}{' '}
        {vehicle?.modelYear}
      </h2>
      <p>{vehicle?.description}</p>

      <Divider />

      <h3>{t('vehicles.vehicleDetails')}</h3>
      <ul className={`${styles.informationList}`}>
        <li>
          <div>{t('vehicles.make')}</div>
          <div>{vehicle?.vehicleMake?.name || '-'}</div>
        </li>
        <li>
          <div>{t('vehicles.model')}</div>
          <div>{vehicle?.vehicleModel?.name || '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.modelYear')}</div>
          <div>{vehicle?.modelYear || '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.bodyType')}</div>
          <div>{vehicle?.bodyType || '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.color')}</div>
          <div>{vehicle?.color || '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.engineSize')}</div>
          <div>{vehicle?.engineSize ? `${vehicle?.engineSize} cm3` : '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.fuelType')}</div>
          <div>{vehicle?.fuelType || '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.gearbox')}</div>
          <div>{vehicle?.gearbox || '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.horsePower')}</div>
          <div>{vehicle?.horsePower ? `${vehicle?.horsePower} HP` : '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleAdditionalDetails.variant')}</div>
          <div>{vehicle?.variant || '-'}</div>
        </li>
        <li>
          <div>{t('vehicles.vin')}</div>
          <div>{vehicle?.vin || '-'}</div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleInformationField.generationLabel')}</div>
          <div>
            {vehicle?.vehicleGeneration ? (
              <>
                <div style={{ fontWeight: 400 }}>
                  {vehicle?.vehicleGeneration.name || '-'}
                </div>
                <div>
                  {vehicle?.vehicleGeneration.yearBegin} -{' '}
                  {vehicle?.vehicleGeneration.yearEnd}
                </div>
              </>
            ) : (
              '-'
            )}
          </div>
        </li>
        <li>
          <div>{t('form.vehicleForm.vehicleInformationField.equipmentLabel')}</div>
          <div>
            {vehicle?.vehicleEquipments?.length > 0 ? (
              vehicle?.vehicleEquipments.map((eq, index) => (
                <span key={eq.id}>
                  {eq.name}
                  {index < vehicle?.vehicleEquipments?.length - 1 && ', '}
                </span>
              ))
            ) : (
              '-'
            )}
          </div>
        </li>
      </ul>
    </>
  );
};

export default VehicleInformation;
